<script>
  import Layout from '@layout/main'
  import { brandComputed } from '@store/helpers'
  import parallax from 'vue-parallaxy'

  export default {
    components: {
      Layout,
      parallax
    },
    props: {
      pageType: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        scrollTop: 0,
        // menuList: [
        //   {
        //     text: '解決方案',
        //     alias: 'solution',
        //     to: {
        //       name: 'brand-solution-list',
        //     },
        //   },
        //   {
        //     text: '產品系列',
        //     alias: 'product',
        //     to: {
        //       name: 'brand-product-list'
        //     },
        //   },
        //   {
        //     text: '課程活動',
        //     alias: 'event',
        //     to: {
        //       name: 'brand-event-list'
        //     },
        //   },
        //   {
        //     text: '最新消息',
        //     alias: 'news',
        //     to: {
        //       name: 'brand-news-list',
        //     },
        //   },
        //   {
        //     text: '成功案例',
        //     alias: 'case',
        //     to: {
        //       name: 'brand-case-list'
        //     },
        //   },
        //   {
        //     text: '檔案下載',
        //     to: {
        //       name: 'brand-file'
        //     },
        //   },
        //   {
        //     text: '產品影片',
        //     alias: 'video',
        //     to: {
        //       name: 'brand-video-list',
        //     },
        //   }
        // ],
        activeMenu: '主頁',
        isMobileSize: false,
      }
    },
    computed: {
      isMenuFixed() {
        return this.scrollTop > 580;
      },
      isDetailPage() {
        const detailPageList = [
          'brand-introduce',
          'brand-solution-item',
          'brand-product-item',
          'brand-event-item',
          'brand-news-item',
          'brand-case-item',
          'brand-video-item',
          'solution-item',
          'product-item',
          // 'event-item',
          'news-item',
          'case-item',
          'video-item',
        ];

        return detailPageList.includes(this.$route.name)
      },
      isIndexPage() {
        const indexPageList = [
          'brand-introduce',
          'brand-item',
          'brand-solution-list',
          'brand-product-list',
          'brand-event-list',
          'brand-news-list',
          'brand-case-list',
          'brand-file',
          'brand-video-list',
        ];

        return indexPageList.includes(this.$route.name)
      },
      isMobilePage() {
        const changeMobilePageList = [
          'brand-solution-item',
          'brand-product-item',
          'brand-event-item',
          'brand-news-item',
          'brand-case-item',
          'brand-video-item',
          'solution-item',
          'product-item',
          // 'event-item',
          'news-item',
          'case-item',
          'video-item',
          'brand-solution-list',
          'brand-product-list',
          'brand-event-list',
          'brand-news-list',
          'brand-news-category',
          'brand-case-list',
          'brand-file',
          'brand-video-list',
          'brand-introduce'
        ]
        return changeMobilePageList.includes(this.$route.name)
      },
      menuList () {
        const routerMap = {
          'solution': 'brand-solution-list',
          'product': 'brand-product-list',
          'event': 'brand-event-list',
          'news': 'brand-news-list',
          'case': 'brand-case-list',
          'file': 'brand-file',
          'video': 'brand-video-list'
        }
        const tabs = this.currentBrand?.tabs || [];
        return tabs.map((item) => {
            return {
              text: item.title,
              alias: item.alias,
              to: {
                name: routerMap[item.alias]
              }
            }
        })
      },
      ...brandComputed
    },
    created() {
      const initActiveMenu = () => {
        const activeMenuItem = this.menuList.filter(item => {
          return item.to.name === this.$route.name
        });

        const detailPageList = [
          'brand-news-category',
          'brand-introduce',
          'solution-item',
          'product-item',
          // 'event-item',
          'news-item',
          'case-item',
          'video-item',
          'brand-solution-item',
          'brand-product-item',
          'brand-event-item',
          'brand-news-item',
          'brand-case-item',
          'brand-video-item',
        ];

        if(detailPageList.includes(this.$route.name)) {
          const active = this.menuList.filter(item => {
            return item.alias === this.pageType
          });
          const routeMap = {
            'brand-introduce': '品牌介紹',
            'brand-news-category': '最新消息'
          }
          if(routeMap.hasOwnProperty(this.$route.name)) {
            this.activeMenu = routeMap[this.$route.name]
          } else {
            this.activeMenu = active.length > 0
              ? active[0].text
              : '主頁';
          }
          
        } else {
          this.activeMenu = activeMenuItem.length > 0
            ? activeMenuItem[0].text
            : '主頁';
        }
      };

      initActiveMenu();
    },
    mounted() {
      this.onScroll();
      window.addEventListener('scroll', this.onScroll);
      const initResizeListener = () => {
        window.addEventListener('resize', this.onMobileSize)
      };

      this.onMobileSize();
      initResizeListener();
    },
    destroyed() {
      window.removeEventListener('scroll', this.onScroll);
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.onMobileSize)
      };

      removeResizeListener();
    },
    methods: {
      onScroll() {
        this.scrollTop = this.getWindowScrollTop();
      },
      getWindowScrollTop() {
        let windowScrollTop = 0;

        if(typeof window.pageYOffset !== 'undefined') {
          windowScrollTop = window.pageYOffset;
        } else if(typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
          windowScrollTop = document.documentElement.scrollTop;
        } else if(typeof document.body !== 'undefined') {
          windowScrollTop = document.body.scrollTop;
        }

        return windowScrollTop;
      },
      onMobileSize() {
        this.isMobileSize = document.body.clientWidth <= 767
      },
      onChangeMenu() {
        const activeMenuItem = this.menuList.filter(item => {
          return item.text === this.activeMenu
        });

        if(activeMenuItem.length > 0) {
          this.$router.push(activeMenuItem[0].to)
        } else {
          this.$router.push({ name: 'brand-item' })
        }
      },
      isActiveMenuItem(item) {
        const detailPageList = [
          'solution-item',
          'product-item',
          // 'event-item',
          'news-item',
          'case-item',
          'video-item',
        ];
        if(detailPageList.includes(this.$route.name) && item === this.pageType) {
          return true
        } else {
          return false
        }
      },
      goTo(to) {
        return {
          ...to,
          params: {
            brandAlias: this.currentBrand?.alias ,
          }
        }
      },
      onMobileMenuOpen(val) {
        this.$emit('mobileOpen', val)
      },
      goToBannerLink() {
        window.open( this.currentBrand.banner_link, "_blank");
      }
    }
  }
</script>

<template>
  <Layout 
    :brand-contact="currentBrand.contact"
    type="brand"
    @mobileOpen="onMobileMenuOpen"
  >
    <div :class="[$style.brandCover, { isMobileStyle: isMobilePage }]">
      <div
        v-if="!isDetailPage"
        class="brandCover__cover"
        :style="`cursor: ${!!currentBrand.banner_link ? 'pointer' : 'auto'}`"
        @click="!!currentBrand.banner_link ? goToBannerLink() : ''"
      >
        <div class="brandCover__parallax">
          <!-- <div 
            class="brandCover__image"
            :class="{ isStyleBrandImage: !!currentBrand.banner_image }" 
            :style="{ backgroundImage: currentBrand.banner_image ? `url('${currentBrand.banner_image}')` : `url('${ require('@assets/images/brand/brand_banner.png') }')`,
            }"
          >
          </div> -->
            <img
              class="brandCover__image"
              alt=""
              :class="{ isStyleBrandImage: !!currentBrand.banner_image }" 
              :src="currentBrand.banner_image || require('@assets/images/brand/brand_banner.png')"
            >
        </div>
        <!-- <parallax
          section-class="brandCover__parallax"
          :speed-factor="0.2"
          >
          <img
            alt=""
            :src="currentBrand.banner_image || require('@assets/images/brand/brand_banner.png')"
          >
        </parallax> -->

        <div class="container position-relative h-100">
          <BaseBreadcrumb
            class="brandCover__breadcrumb"
            custom-class="isStyleWhite isStyleBrand"
          />
        </div>
      </div>
      <div class="container">
        <div class="brandCover__navBox" :class="{ isFixed: isMenuFixed, isDetailPage: isDetailPage }">
          <div class="brandCover__navBoxInner">
            <!--左-->
            <div class="brandCover__navBoxLeft">
              <div class="brandCover__meta">
                <template v-if="isMenuFixed || isDetailPage || isMobileSize">
                  <BaseButton
                    :to="{ name: 'brand-item', params: { brandAlias: currentBrand.alias } }"
                    class="brandCover__avatarBox"
                  >
                    <img
                      alt=""
                      class="brandCover__avatar"
                      :src="currentBrand.logo_image"
                    >
                  </BaseButton>
                </template>
                <template v-else>
                  <BaseButton
                    :href="currentBrand.factory_url"
                    class="brandCover__avatarBox"
                    target="_blank"
                  >
                    <img
                      alt=""
                      class="brandCover__avatar"
                      :src="currentBrand.logo_image"
                    >
                  </BaseButton>
                </template>
                <router-link
                  :to="{ name: 'brand-item', params: { brandAlias: currentBrand.alias } }"
                  class="brandCover__title"
                >
                  {{ currentBrand.title }}
                </router-link>
              </div>
            </div>
            <!--中-->
            <div class="brandCover__navBoxCenter">
              <div class="d-none d-md-block">
                <div class="brandCover__navList">
                  <template v-for="(menuItem, index) in menuList">
                    <div
                      :key="`menuItem-${index}`"
                      class="brandCover__navList__item"
                    >
                      <router-link
                        :to="goTo(menuItem.to)"
                        class="brandCover__navList__link"
                        :class="{ 'isActive': isActiveMenuItem(menuItem.alias) }"
                      >
                        {{ menuItem.text }}
                      </router-link>
                    </div>
                  </template>
                </div>
              </div>
              <div class="d-block d-md-none text-center">
                <BaseButton
                  class="isText"
                  :to="{ 
                    name: 'brand-item',
                    params: {
                      brandAlias: $route.params.brandAlias || currentBrand.alias,
                    },
                  }"
                >
                  {{ activeMenu }} <i class="fal fa-chevron-right"></i>
                </BaseButton>
                <!-- <el-select
                  v-model="activeMenu"
                  class="isStyleMenu isCenter"
                  popper-class="isStyleMenu isCenter"
                  @change="onChangeMenu"
                >
                  <el-option
                    label="主頁"
                    value="主頁"
                  >
                  </el-option>
                  <template v-for="(menuItem, index) in menuList">
                    <el-option
                      :key="menuItem.text"
                      :label="menuItem.text"
                      :value="menuItem.text"
                    >
                    </el-option>
                  </template>
                </el-select> -->
              </div>
            </div>
            <!--右-->
            <div class="brandCover__navBoxRight d-lg-flex d-none">
              <div class="brandCover__toolList">
                <div class="brandCover__toolList__item">
                  <el-dropdown v-if="currentBrand.contact && currentBrand.contact.length > 0" class="isStyleBase">
                    <BaseButton
                      class="isStylePrimary isSmall isFillet brandCover__toolList__tool"
                      style="width: 110px"
                    >
                      <i class="fas fa-phone-volume"></i>
                      <!-- <i class="fal fa-chevron-down ml-2"></i> -->
                    </BaseButton>
                    <el-dropdown-menu slot="dropdown" class="isStylePhone">
                      <el-dropdown-item
                        v-for="(item,$index) in currentBrand.contact"
                        :key="$index"
                      >{{ item.name }}{{ item.gender }} ({{ item.countryCode }}){{ item.phone }} {{
                          item.extension
                            ? `分機 ${ item.extension }`
                            : ''
                        }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <!-- <div class="brandCover__toolList__item">
                  <BaseButton
                    v-if="currentBrand.contact_email"
                    :href="`mailto:${currentBrand.contact_email}`"
                    class="isStyleGray isSmall isOutline isCircle brandCover__toolList__tool"
                  >
                    <i class="fas fa-envelope"></i>
                  </BaseButton>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot/>
  </Layout>
</template>
<style lang="scss" module>
  .brandCover {
    :global {
      .brandCover {
        &__cover {
          position: relative;
          height: 300px;
          overflow: hidden;

          // @include max-xl {
          //   height: 300px
          // }
          // @include max-lg {
          //   height: 225px
          // }
          // @include max-md {
          //   height: 150px
          // }
          // @include max-sm {
          //   height: 125px
          // }
          @include max-lg {
            height: 28vw;
          }
          @include max-md {
            height: 29vw;
          }
        }
        &__parallax {
          width: 100%;
          overflow: hidden;
          height: 100%;
          left: 0;
          position: absolute;
          right: 0;
          top: 0;
        }
        &__image {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          background-repeat: no-repeat;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        &__breadcrumb {
          position: absolute;
          bottom: 1rem;
          left: calc(260px + 2.5rem);
          color: #FFF;

          @include max-lg {
            left: calc(190px + 2.5rem);
          }

          @include max-md {
            display: none;
          }
        }

        &__navBox {
          height: 238px;

          @include max-lg {
            height: 171px;
          }

          @include max-md {
            height: auto;
            border-bottom: 1px solid $color-gray-2;
          }
        }

        &__navBoxInner {
          position: static;
          top: -300px;
          z-index: $z-index-sub-header;
          display: flex;
          flex-wrap: wrap;

          @include max-md {
            flex-direction: column;
          }
        }

        // 選單左邊
        &__navBoxLeft {
          width: 90%;
          padding-bottom: 2rem;

          @include max-md {
            width: 100%;
            padding-bottom: 1.5rem;
          }

          // @include max-md {
          //   width: 100%;
          // }
        }

        // 選單中間
        &__navBoxCenter {
          flex: 0 0 100vw;
          order: 1;
          margin-left: calc((-100vw + #{$container - ($container-gap * 2)}) / 2);
          border-top: 1px solid $color-gray-3;
          box-shadow: 0 10px 20px #2145581A;

          @media screen and (max-width: $container) {
            margin-left: -#{$container-gap};
          }

          @include max-md {
            flex: none;
            margin-left: 0;
            display: none;
            // margin-right: -#{$container-gap};
          }
        }

        // 選單右邊
        &__navBoxRight {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          width: 10%;
          padding-bottom: 2rem;
          // margin-right: 30px;
          @include max-md {
            justify-content: center;
            width: 100%;
          }
        }

        // 頭像 & 標題外框
        &__meta {
          position: relative;
          z-index: 1;
          display: flex;

          @include max-md {
            
          }
        }

        // 頭像外框
        &__avatarBox {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 240px;
          height: 240px;
          padding: 2rem;
          margin-top: -120px;
          margin-right: 3.125em;
          background: #FFF;
          border-radius: 100%;
          -webkit-box-shadow: 0 3px 6px #2145581F;
          box-shadow: 0 3px 12px #2145581F;

          @include max-lg {
            width: 180px;
            height: 180px;
            padding: 2rem;
            margin-top: -90px;
          }

          @include max-md {
            margin-right: 0;
            width: 120px;
            height: 70px;
            border-radius: 0;
            margin-top: -20px;
            padding: 0.2rem;
          }
        }

        // 頭像外框
        &__avatar {
          width: 100%;
        }

        // 標題
        &__title {
          padding-top: 1.25rem;
          font-size: 3em;
          font-weight: 600;
          color: $color-gray-7;
          // text-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
          @include max-lg {
            padding-top: 0.75rem;
            font-size: 2.5rem;
          }

          @include max-md {
            font-size: 1.875rem;
            margin-left: 1.25rem;
          }

          &:hover {
            color: $color-gray-7;
            text-decoration: none;
          }
        }

        // 選單
        &__navList {
          display: flex;
          width: #{$container - $container-gap * 2};
          margin: auto;

          @media screen and (max-width: #{$container - $container-gap * 2}) {
            width: 100vw;
          }

          &__item {
            position: relative;
            flex: 1;

            &:not(:last-child) {
              &::before {
                position: absolute;
                top: 50%;
                right: 0;
                width: 1px;
                height: 27px;
                margin-top: -13.5px;
                content: '';
                background: $color-gray-3;
              }
            }
          }

          &__link {
            display: block;
            padding: 1.625em 0;
            color: $color-gray-7;
            text-align: center;

            @include max-lg {
              padding: 1rem 0;
              font-size: 1rem;
            }

            &:hover {
              color: $color-primary;
              text-decoration: none;
            }

            &.router-link-active, &.isActive {
              position: relative;
              color: $color-primary;

              &::before {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 5px;
                content: '';
                background: $color-primary;
                border-radius: 10px;
              }
            }
          }
        }

        &__toolList {
          display: flex;
          align-items: center;

          &__item:not(:last-child) {
            padding-right: 1rem;
          }

          &__tool {
            &.isFillet {

            }
          }
        }

        &__navBox.isDetailPage {
          height: 65px;
          @include max-lg {
            height: 59px;
          }
          @include max-md {
            height: 56px;
          }
        }


        &__navBox.isFixed, &__navBox.isDetailPage {
          // margin-left: -205px;
          margin-right: #{-($container-menu - $container + $container-gap) / 2};
          margin-left: #{-($container-menu - $container + $container-gap) / 2};

          @media screen and (max-width: $container) {
            margin-right: -$container-gap;
            margin-left: -$container-gap;
          }

          .brandCover {
            &__avatarBox {
              justify-content: flex-start;
              width: 150px;
              height: 36px;
              padding: 0;
              margin-top: 0;
              background-position: left;
              background-size: cover;
              border-radius: 0;
              box-shadow: none;
            }

            &__avatar {
              width: auto;
              max-height: 40px;
              // height: 100%;
            }

            &__navBoxInner {
              position: fixed;
              top: 113px;
              align-items: center;
              width: 100vw;
              margin-left: calc((-100vw + #{$container-menu - $container-gap}) / 2);
              background: rgba(255, 255, 255, 0.95);
              backdrop-filter: blur(3px);
              box-shadow: 0 10px 20px #2145581A;
              transition: top 0.6s;

              @media screen and (max-width: $container) {
                margin-left: 0;
              }

              @include max-lg {
                top: 70px;
              }

              @include max-md {
                top: 48px;
                flex-direction: row;
              }
            }

            &__title {
              display: none;
            }

            &__navBoxLeft {
              width: 180px;
              margin-left: calc((100vw - #{$container-menu}) / 2 + 42px);

              @media screen and (max-width: #{$container-menu + ($container-gap * 2)}) {
                margin-left: 60px;
              }

              @media screen and (max-width: 1200px) {
                width: 133px;
              }

              @include max-lg {
                margin-left: $container-gap;
              }

              @include max-md {
                margin-left: 0;
                // margin: 10px auto 10px $container-gap;
              }
            }

            &__navBoxLeft, &__navBoxRight {
              // width: 213px;
              padding-bottom: 0;

              @include max-xl {
                width: 150px;
              }
            }

            &__navBoxRight {
              width: 220px;
              // margin-left: calc((100vw - 1700px) / 2);
              @include max-lg {
                display: none;
              }
            }

            &__navBoxCenter {
              flex: none;
              order: 0;
              margin-left: 0;
              border-top: none;
              box-shadow: none;

              @include max-lg {
                flex-grow: 1;
                margin-right: $container-gap;
              }

              @include max-md {
                flex-grow: 0;
                .el-select {
                  margin-right: -9px;
                  margin-left: 9px;
                }
              }
            }

            &__toolList {
              &__tool {
                &.isFillet {
                  padding: 0.65rem 1rem;
                  font-size: 1rem;
                }

                &.isCircle {
                  width: 46px;
                  height: 46px;
                  font-size: 1rem;
                }
              }
            }

            &__navList {
              width: 1300px;

              @media screen and (max-width: #{$container-menu + ($container-gap * 2)}) {
                width: calc(100vw - 475px - #{$container-gap * 2});
              }

              @include max-xl {
                width: calc(100vw - 447px - #{$container-gap * 2});
              }

              @include max-lg {
                width: 100%;
              }

              &__link {
                padding: 1.2rem 0.5rem;

                @include max-lg {
                  font-size: 0.875rem;
                }
              }
            }
          }
        }
      }
    }
    &:global {
      &.isMobileStyle {
        @include max-md {
          .brandCover{
            &__cover {
              display: none;
            }
            &__navBox {
              display: flex;
              justify-content: space-between;
              width: 100%;
              // margin-left: -205px;
              margin-right: #{-($container-menu - $container + $container-gap) / 2};
              margin-left: #{-($container-menu - $container + $container-gap) / 2};

              @media screen and (max-width: $container) {
                margin-right: -$container-gap;
                margin-left: -$container-gap;
              }
              .brandCover {
                &__avatarBox {
                  justify-content: flex-start;
                  width: 150px;
                  height: 36px;
                  // padding: 0 0  0 2rem;
                  margin-top: 0;
                  background-position: left;
                  background-size: cover;
                  border-radius: 0;
                  box-shadow: none;
                  background: transparent;
                }

                &__avatar {
                  width: auto;
                  max-height: 50px;
                  // height: 100%;
                }

                &__navBoxInner {
                  position: fixed;
                  top: 48px;
                  flex-direction: row;
                  align-items: center;
                  width: 100vw;
                  margin-left: 0;
                  background: rgba(255, 255, 255, 0.95);
                  backdrop-filter: blur(3px);
                  box-shadow: 0 10px 20px #2145581A;
                  transition: top 0.6s;
                }

                &__title {
                  display: none;
                }

                &__navBoxLeft {
                  width: 50%;
                  padding-left: $container-gap;
                  padding-right: $container-gap;
                  box-shadow: 0px 2px 8px #21455819;
                  // margin: 10px auto 10px $container-gap;
                }
                &__meta {
                  padding: 10px;
                  justify-content: center;
                }
                &__navBoxLeft, &__navBoxRight {
                  width: 50%;
                  padding-bottom: 0;
                
                }

                &__navBoxRight {
                  display: none;
                }

                &__navBoxCenter {
                  order: 0;
                  flex-grow: 0;
                  margin-right: 0;
                  border-top: none;
                  box-shadow: none;
                  width: 50%;
                  padding: 16px $container-gap;
                  box-shadow: 0px 2px 8px #21455819;
                  display: block;
                }

                &__toolList {
                  &__tool {
                    &.isFillet {
                      padding: 0.65rem 1rem;
                      font-size: 1rem;
                    }

                    &.isCircle {
                      width: 46px;
                      height: 46px;
                      font-size: 1rem;
                    }
                  }
                }

                &__navList {
                  width: 100%;

                  &__link {
                    padding: 1.2rem 0.5rem;
                    font-size: 0.875rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

</style>
